// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper_ub_oC","contentLine":"contentLine_hUH9B","resultLine":"resultLine_EwHcL","buttonLine":"buttonLine_J2W3e","leftBotton":"leftBotton_cB0rM"};